import "core-js/modules/es.array.iterator.js";
import React from 'react';
export const useMediaScreenshot = (video, stream) => {
  const canvas = React.useRef(null);
  const [capturer, setCapturer] = React.useState(null);
  const [screenshot, setScreenshot] = React.useState(null);
  const [error, setError] = React.useState(false);
  const initialize = React.useCallback((video, options) => {
    const {
      forceScreenshotSourceSize = false,
      minScreenshotHeight,
      minScreenshotWidth,
      screenshotDimensions
    } = options !== null && options !== void 0 ? options : {};
    let canvasWidth = video.videoWidth;
    let canvasHeight = video.videoHeight;
    if (!forceScreenshotSourceSize) {
      const aspectRatio = canvasWidth / canvasHeight;
      canvasWidth = minScreenshotWidth || video.clientWidth;
      canvasHeight = canvasWidth / aspectRatio;
      if (minScreenshotHeight && canvasHeight < minScreenshotHeight) {
        canvasHeight = minScreenshotHeight;
        canvasWidth = canvasHeight * aspectRatio;
      }
    }
    const canvasElement = document.createElement('canvas');
    canvasElement.width = (screenshotDimensions === null || screenshotDimensions === void 0 ? void 0 : screenshotDimensions.width) || canvasWidth;
    canvasElement.height = (screenshotDimensions === null || screenshotDimensions === void 0 ? void 0 : screenshotDimensions.height) || canvasHeight;
    canvas.current = canvasElement;
  }, []);
  const capture = React.useCallback(options => {
    const {
      imageSmoothing = true,
      mirrored = true,
      screenshotDimensions,
      screenshotFormat = 'image/webp',
      screenshotQuality = 0.92
    } = options !== null && options !== void 0 ? options : {};
    if (!video || !stream || !video.videoHeight) setError(true);else {
      if (!canvas.current) initialize(video, options);
      if (canvas.current) {
        const context = canvas.current.getContext('2d');
        if (context) {
          var _screenshotDimensions, _screenshotDimensions2;
          if (mirrored) {
            context.translate(canvas.current.width, 0);
            context.scale(-1, 1);
          }
          const screenshotWidth = (_screenshotDimensions = screenshotDimensions === null || screenshotDimensions === void 0 ? void 0 : screenshotDimensions.width) !== null && _screenshotDimensions !== void 0 ? _screenshotDimensions : canvas.current.width;
          const screenshotHeight = (_screenshotDimensions2 = screenshotDimensions === null || screenshotDimensions === void 0 ? void 0 : screenshotDimensions.height) !== null && _screenshotDimensions2 !== void 0 ? _screenshotDimensions2 : canvas.current.height;
          context.imageSmoothingEnabled = imageSmoothing;
          context.drawImage(video, 0, 0, screenshotWidth, screenshotHeight);
          if (mirrored) {
            context.scale(-1, 1);
            context.translate(-canvas.current.width, 0);
          }
          setError(false);
          const screenshot = canvas.current.toDataURL(screenshotFormat, screenshotQuality);
          setScreenshot(screenshot);
          return screenshot;
        } else setError(true);
      }
    }
    return null;
  }, [video, stream]);
  React.useEffect(() => {
    if (video && stream) setCapturer({
      capture
    });
  }, [video, stream]);
  return [capturer, {
    screenshot,
    error
  }];
};